import { render, staticRenderFns } from "./CheckSafetyIncidentLogModal.vue?vue&type=template&id=167b0d9c"
import script from "./CheckSafetyIncidentLogModal.vue?vue&type=script&lang=js"
export * from "./CheckSafetyIncidentLogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports